import Text from '../Text';
import { Container } from './styledComponents';
import { ENUM_COLORS, ENUM_FONTS } from '../Text/textEnums';
import { Icon } from '../Icon';

interface Props {
  path: string;
}

export const NavigationBreadcrumb = (props: Props) => {
  const { path } = props;

  return (
    <Container>
      <Icon color="grey" name="settings" size="small" />
      <Icon color="grey" name="chevron" size="small" />
      <Text color={ENUM_COLORS.IP_BLACK_5} font={ENUM_FONTS.TEXT_MIDDLE_NORMAL}>
        Back-office
      </Text>
      <Icon color="grey" name="chevron" size="small" />
      <Text color={ENUM_COLORS.IP_BLACK_5} font={ENUM_FONTS.TEXT_MIDDLE_NORMAL}>
        {path}
      </Text>
    </Container>
  );
};
